/**
 * Verify if a string is null, empty or whitespace
 * @param value
 * @returns boolean
 */
export function isBlank(value: string): boolean {
  return !value || /^\s*$/.test(value);
}
